module.exports = __webpack_public_path__ + "img/2.bef59d26.jpg";